import { useEffect } from "react";

export default function useBlockInspect() {
  useEffect(() => {
    if (typeof window === "undefined") return;

    const onKeyDown = (e) => {
      const key = e.key?.toUpperCase();
      if (
        key === "F12" ||
        (e.ctrlKey && e.shiftKey && ["I", "J", "C"].includes(key)) ||
        (e.ctrlKey && key === "U")
      ) {
        e.preventDefault();
      }
    };

    const onContextMenu = (e) => e.preventDefault();

    window.addEventListener("keydown", onKeyDown, true);
    window.addEventListener("contextmenu", onContextMenu, true);

    return () => {
      window.removeEventListener("keydown", onKeyDown, true);
      window.removeEventListener("contextmenu", onContextMenu, true);
    };
  }, []);
}
